function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState, memo, useReducer } from 'react';
import { Row, Col, Spinner } from 'reactstrap';
import { _translate, _Api } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import { useQuestion } from "../../../question/question-context";
import Collector from "../../../../services/collector";
import useUtils from "./use-utils";
import Timer from "./timer/timer";
import Modes from "./modes";
import AddStep from "./journey/add_step";
import Step from "./journey/step";
var defaultValue = [{
  time: '00:00',
  mode: null
}, {
  time: '18:00'
}];
var reducer = function reducer(state, action) {
  var newState = _toConsumableArray(state);
  switch (action.type) {
    case 'all':
      return action.value;
    default:
  }
  if (!newState[action.index]) {
    newState[action.index] = [];
  }
  newState[action.index][action.type] = action.value;
  return newState;
};

/**
 * @todo Séparer en plusieurs composant fonctionnel.
 */
var SelectionJourney = function SelectionJourney(props) {
  var _journeyCtx$, _journeyCtx$2, _journeyCtx$3, _journeyCtx$4, _journeyCtx$maxIndex, _journeyCtx$maxIndex2, _journeyCtx$maxIndex3;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var currentOrder = collector.currentOrder,
    currentQuestion = collector.currentQuestion,
    responses = collector.responses,
    diagId = collector.diagId,
    historic = collector.historic;
  var _useQuestion = useQuestion(),
    _useQuestion2 = _slicedToArray(_useQuestion, 2),
    journeyCtx = _useQuestion2[0],
    dispatch = _useQuestion2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var maxIndex = journeyCtx.length - 1;
  var onChange = props.onChange;
  var _useUtils = useUtils(),
    responsesCategorized = _useUtils.responsesCategorized,
    Journey = _useUtils.Journey,
    Layout = _useUtils.Layout;
  var getResponseFormatted = function getResponseFormatted(journey) {
    var journeyFormatted = {};
    var questionAlias = currentQuestion.alias;
    journey.forEach(function (item, index) {
      Object.keys(item).forEach(function (field) {
        var _value, _value2;
        if (field === 'errors' || field === 'error') {
          return;
        }
        var value = item[field];
        switch (field) {
          case 'departure':
          case 'arrival':
          case 'line':
            value = ((_value = value) === null || _value === void 0 ? void 0 : _value._id) || ((_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.id) || value;
            break;
          case 'mode':
            value = value;
            break;
          default:
            break;
        }
        journeyFormatted["".concat(questionAlias, "_").concat(field, "_j").concat(index)] = value;
      });
    });
    return journeyFormatted;
  };
  var handleValueChange = function handleValueChange(value, currentIndex, field) {
    var tmpResponse = _toConsumableArray(journeyCtx);
    if (!tmpResponse[currentIndex]) {
      tmpResponse[currentIndex] = {};
    }
    if (field === 'time') {
      var _tmpResponse$previous, _tmpResponse$next;
      var previous = currentIndex - 1;
      var next = currentIndex + 1;
      if (!tmpResponse.error) {
        tmpResponse[currentIndex].error = {};
      }
      var message = null;
      if (tmpResponse[previous] && previous >= 0 && value <= ((_tmpResponse$previous = tmpResponse[previous]) === null || _tmpResponse$previous === void 0 ? void 0 : _tmpResponse$previous.time)) {
        message = 'collectorapp_warning_time_must_be_superior_to_previous';
        if (!tmpResponse[previous].error) tmpResponse[previous].error = {};
        tmpResponse[previous].error.time = null;
      } else if (next <= tmpResponse.length - 1 && value >= ((_tmpResponse$next = tmpResponse[next]) === null || _tmpResponse$next === void 0 ? void 0 : _tmpResponse$next.time)) {
        message = 'collectorapp_warning_time_must_be_inferior_to_next';
        if (!tmpResponse[next].error) tmpResponse[next].error = {};
        tmpResponse[next].error.time = null;
      } else {
        // A cet index on'a pas d'erreur sur le champs alors ses voisins non plus.
        if (tmpResponse[next]) {
          if (!tmpResponse[next].error) tmpResponse[next].error = {};
          tmpResponse[next].error.time = null;
        }
        if (tmpResponse[previous]) {
          if (!tmpResponse[previous].error) tmpResponse[previous].error = {};
          tmpResponse[previous].error.time = null;
        }
      }
      tmpResponse[currentIndex].error.time = message;
    }
    if (field === 'mode') {
      tmpResponse[currentIndex]['carpooling_app'] = null;
      tmpResponse[currentIndex]['distance_parking_to_destination'] = null;
      tmpResponse[currentIndex]['distance'] = null;
      tmpResponse[currentIndex]['nb_passengers'] = null;
      tmpResponse[currentIndex]['nb_passtime_to_parkengers'] = null;
      tmpResponse[currentIndex]['departure'] = null;
      tmpResponse[currentIndex]['arrival'] = null;
      tmpResponse[currentIndex]['line'] = null;
    }
    tmpResponse[currentIndex][field] = value;
    dispatch({
      type: 'all',
      value: tmpResponse
    });
    onChange({}, getResponseFormatted(tmpResponse), null, null, currentIndex, true);
  };
  var handleAddStep = function handleAddStep(currentIndex) {
    var tmpJourneyCtx = _toConsumableArray(journeyCtx);
    tmpJourneyCtx.splice(currentIndex + 1, 0, {
      time: tmpJourneyCtx[currentIndex].time || '00:00'
    });
    onChange([], getResponseFormatted(tmpJourneyCtx), null, null, currentIndex + 1, true);
    dispatch({
      type: 'all',
      value: tmpJourneyCtx
    });
  };
  var handleDeleteStep = function handleDeleteStep(currentIndex) {
    var tmpJourneyCtx = _toConsumableArray(journeyCtx);
    tmpJourneyCtx.splice(currentIndex, 1);
    onChange([], getResponseFormatted(tmpJourneyCtx), null, null, currentIndex, true, true);
    dispatch({
      type: 'all',
      value: tmpJourneyCtx
    });
  };

  /**
   * Permet d'initaliser les valeurs si elles existent déjà
   * Depuis l'historique et en rechargeant les réponses.
   */
  var onInit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var responsesFromHistoric, historicResponse, question, _historic$list, _historic$list2, currHistoricOrder, apiResponse, formatResponses, formatted;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
            historicResponse = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
            if (historicResponse) {
              _context2.next = 5;
              break;
            }
            dispatch({
              type: 'all',
              value: defaultValue
            });
            return _context2.abrupt("return");
          case 5:
            setLoading(true);
            question = null; // Permet de récupérer si on fait un retour arrière ou avant.
            if (!(historic !== null && historic !== void 0 && historic.list)) {
              _context2.next = 20;
              break;
            }
            currHistoricOrder = historic.current ? historic === null || historic === void 0 || (_historic$list = historic.list[historic.current.index - 1]) === null || _historic$list === void 0 ? void 0 : _historic$list.order : (_historic$list2 = historic.list[historic.list.length - 1]) === null || _historic$list2 === void 0 ? void 0 : _historic$list2.order;
            _context2.prev = 9;
            _context2.next = 12;
            return Collector.getNextQuestion(diagId, currHistoricOrder, responses);
          case 12:
            apiResponse = _context2.sent;
            question = JSON.parse(apiResponse.data.question);
            dispatcher({
              type: 'currentQuestion',
              value: JSON.parse(apiResponse.data.question)
            });
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](9);
            console.error('QUESTION', _context2.t0);
          case 20:
            formatResponses = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(histResp) {
                var formatted, getAlias, aliasHR, i, oldAlias, alias, splitAlias, index, value, respDeparture, responseLine, _i, _question$expectedRes;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      formatted = _toConsumableArray(defaultValue);
                      if (!(null === histResp || Object.keys(histResp).length === 0)) {
                        _context.next = 3;
                        break;
                      }
                      return _context.abrupt("return", formatted);
                    case 3:
                      getAlias = function getAlias(oldAlias) {
                        var _question;
                        if (!question) {
                          return;
                        }
                        var currentAlias = oldAlias.replace((_question = question) === null || _question === void 0 ? void 0 : _question.alias, '');
                        if (currentAlias.search('departure') !== -1) {
                          return 'departure';
                        }
                        if (currentAlias.search('arrival') !== -1) {
                          return 'arrival';
                        }
                        if (currentAlias.search('line') !== -1) {
                          return 'line';
                        }
                        if (currentAlias.search('time') !== -1) {
                          return 'time';
                        }
                        if (currentAlias.search('mode') !== -1) {
                          return 'mode';
                        }
                        if (currentAlias.search('carpooling_app') !== -1) {
                          return 'carpooling_app';
                        }
                        if (currentAlias.search('distance_parking_to_destination') !== -1) {
                          return 'distance_parking_to_destination';
                        }
                        if (currentAlias.search('distance') !== -1) {
                          return 'distance';
                        }
                        if (currentAlias.search('nb_passengers') !== -1) {
                          return 'nb_passengers';
                        }
                        if (currentAlias.search('time_to_park') !== -1) {
                          return 'time_to_park';
                        }
                        return null;
                      }; // ON récupère les réponses pour faire un for classique
                      aliasHR = Object.keys(histResp);
                      i = 0;
                    case 6:
                      if (!(i < aliasHR.length)) {
                        _context.next = 50;
                        break;
                      }
                      oldAlias = aliasHR[i];
                      alias = getAlias(oldAlias);
                      splitAlias = oldAlias.split('_j');
                      index = splitAlias[splitAlias.length - 1];
                      value = histResp[oldAlias];
                      if (!(null === alias)) {
                        _context.next = 14;
                        break;
                      }
                      return _context.abrupt("continue", 47);
                    case 14:
                      _context.prev = 14;
                      _context.t0 = alias;
                      _context.next = _context.t0 === 'departure' ? 18 : _context.t0 === 'arrival' ? 18 : _context.t0 === 'line' ? 24 : _context.t0 === 'mode' ? 30 : 40;
                      break;
                    case 18:
                      if (!(value && value !== 'NA')) {
                        _context.next = 23;
                        break;
                      }
                      _context.next = 21;
                      return _Api.get("/points/".concat(value, "/public"));
                    case 21:
                      respDeparture = _context.sent;
                      if (respDeparture.data) {
                        value = respDeparture.data;
                      }
                    case 23:
                      return _context.abrupt("break", 40);
                    case 24:
                      if (!(value && value !== 'NA')) {
                        _context.next = 29;
                        break;
                      }
                      _context.next = 27;
                      return _Api.get("/points/".concat(value, "/public"));
                    case 27:
                      responseLine = _context.sent;
                      if (responseLine.data) {
                        value = responseLine.data;
                      }
                    case 29:
                      return _context.abrupt("break", 40);
                    case 30:
                      if (!question.expectedResponses) {
                        _context.next = 39;
                        break;
                      }
                      _i = 0;
                    case 32:
                      if (!(_i < question.expectedResponses.length)) {
                        _context.next = 39;
                        break;
                      }
                      if (!(((_question$expectedRes = question.expectedResponses[_i]) === null || _question$expectedRes === void 0 ? void 0 : _question$expectedRes.alias) === value)) {
                        _context.next = 36;
                        break;
                      }
                      value = question.expectedResponses[_i];
                      return _context.abrupt("break", 39);
                    case 36:
                      _i++;
                      _context.next = 32;
                      break;
                    case 39:
                      return _context.abrupt("break", 40);
                    case 40:
                      _context.next = 45;
                      break;
                    case 42:
                      _context.prev = 42;
                      _context.t1 = _context["catch"](14);
                      console.error(_context.t1);
                    case 45:
                      if (!formatted[index]) {
                        formatted[index] = {};
                      }
                      formatted[index][alias] = value;
                    case 47:
                      i++;
                      _context.next = 6;
                      break;
                    case 50:
                      return _context.abrupt("return", formatted);
                    case 51:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[14, 42]]);
              }));
              return function formatResponses(_x) {
                return _ref2.apply(this, arguments);
              };
            }();
            _context2.next = 23;
            return formatResponses(historicResponse);
          case 23:
            formatted = _context2.sent;
            dispatch({
              type: 'all',
              value: formatted
            });
            setLoading(false);
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[9, 17]]);
    }));
    return function onInit() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    onInit();
    return function () {
      defaultValue = [{
        time: '00:00'
      }, {
        time: '00:00'
      }];
      dispatch({
        type: 'all',
        value: [{
          time: '00:00'
        }, {
          time: '00:00'
        }]
      });
    };
  }, [historic.current]);
  if (loading) {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
  return /*#__PURE__*/React.createElement(Journey.Provider, {
    value: [journeyCtx, dispatch]
  }, /*#__PURE__*/React.createElement("div", {
    className: "sequence-journey"
  }, /*#__PURE__*/React.createElement(Layout.RowCentered, null, /*#__PURE__*/React.createElement(Layout.LeftCol, null, /*#__PURE__*/React.createElement(Journey.Flag, {
    index: 0
  })), /*#__PURE__*/React.createElement(Layout.RightCol, null, /*#__PURE__*/React.createElement("h4", null, _translate('collectorapp_departure')))), /*#__PURE__*/React.createElement(Layout.RowCentered, null, /*#__PURE__*/React.createElement(Layout.LeftCol, null, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, {
    className: "h-100"
  })), /*#__PURE__*/React.createElement(Layout.RightCol, null, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, {
    className: ""
  }), /*#__PURE__*/React.createElement(Row, {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: " d-flex justify-content-center p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-start pr-3"
  }, _translate('Heure de départ')), ' ', /*#__PURE__*/React.createElement(Timer, {
    index: 0,
    value: (_journeyCtx$ = journeyCtx[0]) === null || _journeyCtx$ === void 0 ? void 0 : _journeyCtx$.time,
    error: (_journeyCtx$2 = journeyCtx[0]) === null || _journeyCtx$2 === void 0 || (_journeyCtx$2 = _journeyCtx$2.error) === null || _journeyCtx$2 === void 0 ? void 0 : _journeyCtx$2.time,
    onChange: function onChange(val) {
      return handleValueChange(val, 0, 'time');
    }
  })), /*#__PURE__*/React.createElement(Col, {
    className: "col-12 position-relative"
  }, /*#__PURE__*/React.createElement("span", {
    className: "journey-form-error"
  }, (_journeyCtx$3 = journeyCtx[0]) !== null && _journeyCtx$3 !== void 0 && (_journeyCtx$3 = _journeyCtx$3.error) !== null && _journeyCtx$3 !== void 0 && _journeyCtx$3.time ? _translate((_journeyCtx$4 = journeyCtx[0]) === null || _journeyCtx$4 === void 0 || (_journeyCtx$4 = _journeyCtx$4.error) === null || _journeyCtx$4 === void 0 ? void 0 : _journeyCtx$4.time) : null)), /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-1"
  }, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, null)), /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-3"
  }, /*#__PURE__*/React.createElement(Modes, {
    index: "0",
    categories: responsesCategorized,
    onChange: function onChange(value, type) {
      return handleValueChange(value, 0, type);
    }
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-1"
  }, /*#__PURE__*/React.createElement(AddStep, {
    addTransport: function addTransport() {
      return handleAddStep(0);
    }
  }))))), Array.isArray(journeyCtx) && journeyCtx.map(function (response, index) {
    if (index === 0 || index === journeyCtx.length - 1) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Step, {
      key: "step_".concat(index),
      index: index,
      value: response,
      onModeChange: function onModeChange(mode, type) {
        return handleValueChange(mode, index, type);
      },
      onTimeChange: function onTimeChange(time) {
        return handleValueChange(time, index, 'time');
      },
      onAddStep: function onAddStep() {
        return handleAddStep(index);
      },
      onDeleteStep: function onDeleteStep() {
        return handleDeleteStep(index);
      },
      responsesCategorized: responsesCategorized
    });
  }), /*#__PURE__*/React.createElement(Layout.RowCentered, null, /*#__PURE__*/React.createElement(Layout.LeftCol, null, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, {
    className: "h-100"
  })), /*#__PURE__*/React.createElement(Layout.RightCol, null, /*#__PURE__*/React.createElement(Row, {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: " d-flex justify-content-center p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-start pr-3"
  }, _translate("Heure d'arrivée")), ' ', /*#__PURE__*/React.createElement(Timer, {
    value: (_journeyCtx$maxIndex = journeyCtx[maxIndex]) === null || _journeyCtx$maxIndex === void 0 ? void 0 : _journeyCtx$maxIndex.time,
    onChange: function onChange(val) {
      return handleValueChange(val, maxIndex, 'time');
    }
  })), /*#__PURE__*/React.createElement(Col, {
    className: "col-12 position-relative"
  }, /*#__PURE__*/React.createElement("span", {
    className: "journey-form-error"
  }, (_journeyCtx$maxIndex2 = journeyCtx[maxIndex]) !== null && _journeyCtx$maxIndex2 !== void 0 && (_journeyCtx$maxIndex2 = _journeyCtx$maxIndex2.error) !== null && _journeyCtx$maxIndex2 !== void 0 && _journeyCtx$maxIndex2.time ? _translate((_journeyCtx$maxIndex3 = journeyCtx[maxIndex]) === null || _journeyCtx$maxIndex3 === void 0 || (_journeyCtx$maxIndex3 = _journeyCtx$maxIndex3.error) === null || _journeyCtx$maxIndex3 === void 0 ? void 0 : _journeyCtx$maxIndex3.time) : null)), /*#__PURE__*/React.createElement(Col, {
    sm: "12 mt-1"
  }, /*#__PURE__*/React.createElement(Journey.VerticaleDashedLine, null))))), /*#__PURE__*/React.createElement(Layout.RowCentered, null, /*#__PURE__*/React.createElement(Layout.LeftCol, null, /*#__PURE__*/React.createElement(Journey.Flag, {
    index: 1,
    isBetween: false
  })), /*#__PURE__*/React.createElement(Layout.RightCol, null, /*#__PURE__*/React.createElement("h4", null, _translate('collectorapp_arrival'))))));
};
SelectionJourney.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
SelectionJourney.defaultProps = {
  elements: [],
  responses: {}
};
export default /*#__PURE__*/memo(SelectionJourney);